<template>
     <el-dialog :visible.sync="_value" width="600px">
         <div slot="title" style="color: #3A82FF,text-align: center;">账号登录</div>
         <el-form label-width="100px"  style="padding-right:30px">
             <el-form-item label="手机号码">
                <div class="tel-box">
                    <div class="tel-group" style="width: 100%;border-right:1px solid #ddd;">
                        <span class="input-group-icon">
                            <i class="el-icon-phone"></i>
                        </span>
                        <input maxlength="11" type="tel" class="tel-input" v-model="phone" name="phone" placeholder="请输入手机号码">
                    </div>
                </div>
             </el-form-item>
             <el-form-item label="验证码">
                <div class="tel-box">
                 
                    <div class="tel-group" >
                        <span class="input-group-icon" style="font-size:24px;">
                            <i class="el-icon-message"></i>
                        </span>
                        <input class="msg-input" name="code" placeholder="请输入短信验证码" v-model="code">
                    </div>
                    <el-button  @click="sendcode" type="button" :disabled="!btnenable ||!cansend" class="send-code-button">{{ btntext }}</el-button>
                </div>
             </el-form-item>
         </el-form>
                <a class="login-button" href="javascript:;" @click="bindTel">登 录</a>

    </el-dialog>
</template>

<script>
   export default {
        mounted() {
            // this.chartTimeTypeChange()
        },
        props: {
            value:{
                type:Boolean,
                default:false
            },
        },
        computed: {
            _value: {
                get() {
                    return this.value;
                    
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            },
        data: function() {
            return {
                isLogin: true,
                btntext: '发送验证码',
                btnenable: false,
                cansend: true,
                phone: '',
                code: '',
                timer: null,
                leftTime: 60,
                user: null,
                redirect: '',
                btn: true
            };
        },
        watch: {
            'phone': {
                handler: function (val) {
                    let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
                    if (reg.test(val)) {
                        this.btnenable = true
                    } else {
                        this.btnenable = false
                    }
                },
                deep: true
            }
        },
        methods: {
            sendcode: function () {
                let tel = /^1\d{10}$/
                if (!this.phone) {
                    this.$message.error('请您输入手机号码')
                    return
                } else if (!tel.test(this.phone)) {
                    this.$message.error('您输入的手机号码有误')
                    return
                }
                this.cansend = false
                this.leftTime = 60
                this.btntext = this.leftTime + 's后重发'
                this.timer = setInterval(this.enableResend, 1000)
                this.$request('v5/user/code',{tel: this.phone}).then((xhr, res) => {
                    if (res.code > 0) {
                        this.$message.error(res.msg)
                    } else {
                        this.showmsg = true
                        this.$message.success('发送成功')
                        window.setTimeout(this.hideMsg, 1000)
                    }
                }).catch(function() {
                    this.$message.error('发送验证码失败，请重试')
                    clearInterval(this.timer)
                    this.cansend = true
                    this.btn = true
                })
            },
        enableResend: function () {
            this.btntext = this.leftTime-- + 's后重发'
            if (this.leftTime === 0) {
                this.cansend = true
                clearInterval(this.timer)
                this.btntext = "发送验证码"
            }
        },
        bindTel: function () {
            let self = this
            let cd = /^\d{4}$/
            if (!this.code) {
                this.$message.error('请您输入验证码')
                return
            } else if (!cd.test(this.code)) {
                this.$message.error('您输入验证码的有误')
                return
            }
            this.btn = false
            this.$request('v5/user/login', {tel: this.phone, code: this.code}).then((xhr, res) => {
                self.btn = true
                if (res.code === 0) {
                    window.localStorage.UserTelAll = this.phone
                    window.localStorage.UserId = res.data.User.Id || ''
                    window.localStorage.UserTel = res.data.User.Tel || ''
                    window.localStorage.UserIcon = res.data.User.Icon || ''
                    window.localStorage.UserName = res.data.User.Name || ''
                    window.localStorage.AccessToken = res.data.Token
                    this.$store.state.UserTel = res.data.User.Tel
                    if (res.data.User.Grey) {
                        window.localStorage.grey = true
                    }
                    this.$message.success('登录成功！')
                    this._value= false
                    this.$emit('callback')
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(function() {
                self.btn = true
            })
        },
        }
    }

</script>
<style scoped>
.send-code-button-disable{
	width: 40%;
	height: 40px;
	border: 0;
	border-radius: 0;
	background:linear-gradient(to right, #F75F08 , #F1A274);
	color: #fff;
	font-size: 17px;
	font-weight: 300;
	text-align: center;
	float: left;
	cursor: pointer;
	display: block;
	text-decoration: none;
}
.send-code-button{
	width: 40%;
	height: 40px;
	border: 0;
	border-radius: 0;
	background: #3A82FF;
	color: #fff;
	font-size: 17px;
	font-weight: 300;
	text-align: center;
	cursor: pointer;
	float: left;
	display: block;
	text-decoration: none;
}
.tel-group{
	width: 60%;
	height: 40px;
	line-height: 40px;
	border: 1px solid #ddd;
	border-right: 0;
	background-color: #fff;
	display: flex;
	float: left;
}
.input-group-icon{
	width: 48px;
	max-width: 48px;
	height: 38px;
	line-height: 38px;
	text-align: center;
	font-size: 27px;
}
.tel-input,.msg-input{
	/* padding: 10px 0; */
	margin: 0;
	/*width: 79%;*/
	height: 38px;
	line-height: 38px;
	font-size: 18px;
	font-weight: 300;
	/*float: left;*/
	outline: none;
	border: 0;
	flex: 1 auto;
}
.tel-box{
	margin-bottom: 15px;
	width: 100%;
	height: 40px;
    display: flex;
}
.login-button{
	width: 60%;
    margin:0 auto;
	height: 55px;
	line-height: 55px;
	border: 0;
	background: #3A82FF;
    color: #FFFFFF;
	font-size: 18px;
	font-weight: 300;
	text-align: center;
	display: block;
	cursor: pointer;
	text-decoration: none;
}
.el-button.is-disabled, .el-button.is-disabled:hover, .el-button.is-disabled:focus {
    background: #888;
    color: #fff;
    cursor: not-allowed;
}
</style>
